import { render, staticRenderFns } from "./dgPayment.vue?vue&type=template&id=bdf1dd6a&scoped=true"
import script from "./dgPayment.vue?vue&type=script&lang=js"
export * from "./dgPayment.vue?vue&type=script&lang=js"
import style0 from "./dgPayment.vue?vue&type=style&index=0&id=bdf1dd6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf1dd6a",
  null
  
)

export default component.exports